<swiper [id]="id" [config]="swiperConfig" class="swiper" #swiper>
  <div class="swiper-wrapper">
    <div class="swiper-slide" *ngFor="let slide of slides; let i = index">
      <!-- dinamico -->
      <neo-elemento-imagen-slide [imagen]="slide.media" [titulo]="slide.titulo" [tamanoTitulo]="tamanoTitulo" [texto]="slide.texto" [boton]="slide.boton"
        [enlace]="slide.enlace" (clickElemento)="mostrarGaleria ? gallery.openPreview(i) : null">
      </neo-elemento-imagen-slide>
    </div>
  </div>
  <!-- Paginación -->
  <div class="swiper-pagination-wrapper" *ngIf="slides.length > 1 && this.paginacion">
    <div class="swiper-pagination"></div>
    <div *ngIf="tipoPaginacion === _TipoPaginadorSliderEnum.fraction" class="swiper-progressbar"></div>
  </div>
  <!-- Handlers -->
  <ng-container *ngIf="handlers">
    <div class="swiper-button-next"><neo-icono [iconoClase]="iconHandlerNext"></neo-icono></div>
    <div class="swiper-button-prev"><neo-icono [iconoClase]="iconHandlerPrev"></neo-icono></div>
  </ng-container>
</swiper>

<!-- Galería -->
<div class="gallery-wrapper">
  <ngx-gallery #gallery [options]="galleryOptions" [images]="galleryImages" class="ngx-gallery"></ngx-gallery>
</div>
